// 后台固定按北京时间显示与输入（UTC+8，无夏令时，决策 D174）：接口与存储仍是 UTC，只在展示与解析输入时换算。
// 不引日期库：偏移固定，把时刻平移 8 小时后用 getUTC* 读到的就是北京时间的各字段，反向把北京时间的字段减 8 小时得到时刻。

const TZ_OFFSET_MS = 8 * 3_600_000;

/** RFC 3339 里的北京时区偏移，拼在没有时区的本地时间文本后面解析。 */
export const TZ_OFFSET = "+08:00";

/** 平移 8 小时：返回值的 getUTC* 与 toISOString 读到的就是北京时间的年月日时分秒。只用来读字段，不是真实时刻。 */
export function toBeijing(d: Date): Date {
  return new Date(d.getTime() + TZ_OFFSET_MS);
}

/** 北京时间的年月日时分秒转真实时刻；month 从 0 起，与 Date.UTC 一致。 */
export function fromBeijing(y: number, m: number, d: number, h = 0, mi = 0, s = 0): Date {
  return new Date(Date.UTC(y, m, d, h, mi, s) - TZ_OFFSET_MS);
}

/** 时刻所在的北京日期 YYYY-MM-DD。 */
export function beijingDay(d: Date): string {
  return toBeijing(d).toISOString().slice(0, 10);
}
